export const ElementVisible = Object.freeze({sm: 0, md: 1, lg: 2, xl: 3});
export const ElementColorClasses = ['primary', 'secondary', 'blue', 'green', 'orange', 'red', 'white', 'grey', 'darkGrey', 'black'];
